'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var pathOr = require('ramda/src/pathOr');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var pathOr__default = /*#__PURE__*/_interopDefaultLegacy(pathOr);

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}

var User$1 = /*#__PURE__*/_createClass(function User(name, email, subscriptions) {
  var claims = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var id = arguments.length > 4 ? arguments[4] : undefined;
  var contactFirmId = arguments.length > 5 ? arguments[5] : undefined;
  var firmType = arguments.length > 6 ? arguments[6] : undefined;
  var subscription_count_classic = arguments.length > 7 ? arguments[7] : undefined;
  var subscription_count_pro = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : "0";
  var roles = arguments.length > 9 ? arguments[9] : undefined;
  var preqinMaintenanceUserId = arguments.length > 10 ? arguments[10] : undefined;
  var preqinMaintenanceUserInitials = arguments.length > 11 ? arguments[11] : undefined;
  var preqinFirmId = arguments.length > 12 ? arguments[12] : undefined;
  var preqinFirmName = arguments.length > 13 ? arguments[13] : undefined;
  var preqin_firmCountry = arguments.length > 14 ? arguments[14] : undefined;
  _classCallCheck(this, User);
  this.name = name;
  this.email = email;
  this.subscriptions = subscriptions;
  this.claims = claims;
  this.id = id;
  this.contactFirmId = contactFirmId;
  this.firmType = firmType;
  this.internal = !!email.match(/preqin/gi);
  this.subscription_count_classic = subscription_count_classic;
  this.subscription_count_pro = subscription_count_pro;
  this.isFree = Number(subscription_count_pro) === 0;
  this.roles = roles;
  this.preqinMaintenanceUserId = preqinMaintenanceUserId;
  this.preqinMaintenanceUserInitials = preqinMaintenanceUserInitials;
  this.preqinFirmId = preqinFirmId;
  this.preqinFirmName = preqinFirmName;
  this.preqin_firmCountry = preqin_firmCountry;
});

var User = /*#__PURE__*/_createClass(function User(name, email, subscriptions) {
  var claims = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var id = arguments.length > 4 ? arguments[4] : undefined;
  var contactFirmId = arguments.length > 5 ? arguments[5] : undefined;
  var firmId = arguments.length > 6 ? arguments[6] : undefined;
  var firmName = arguments.length > 7 ? arguments[7] : undefined;
  var firmType = arguments.length > 8 ? arguments[8] : undefined;
  var preqinFirmType = arguments.length > 9 ? arguments[9] : undefined;
  var subscription_count_classic = arguments.length > 10 ? arguments[10] : undefined;
  var subscription_count_pro = arguments.length > 11 && arguments[11] !== undefined ? arguments[11] : "0";
  var purchasedPackage = arguments.length > 12 && arguments[12] !== undefined ? arguments[12] : {};
  var region = arguments.length > 13 ? arguments[13] : undefined;
  var preqin_firmCountry = arguments.length > 14 ? arguments[14] : undefined;
  _classCallCheck(this, User);
  this.name = name;
  this.email = email;
  this.subscriptions = subscriptions;
  this.claims = claims;
  this.id = id;
  this.contactFirmId = contactFirmId;
  this.firmId = firmId;
  this.firmName = firmName;
  this.firmType = firmType;
  this.internal = !!email.match(/preqin/gi);
  this.subscription_count_classic = subscription_count_classic;
  this.subscription_count_pro = subscription_count_pro;
  this.isFree = Number(subscription_count_pro) === 0;
  this.purchasedPackage = purchasedPackage;
  this.preqin_firmType = preqinFirmType;
  this.region = region;
  this.preqin_firmCountry = preqin_firmCountry;
});

//New Helper functions for New Package / Subs based users.

// Add on Access helper function - Checks the users Add on access from the purchased package and returns true / false
var hasAddOnAccess = function hasAddOnAccess(packageAddons, addOn) {
  var isAddOnsArray = Array.isArray(addOn);
  var addOns = packageAddons && Array.isArray(packageAddons) ? packageAddons.map(function (item) {
    return item.toLowerCase();
  }) : packageAddons && packageAddons.toLowerCase();
  var hasAddOn;
  if (!isAddOnsArray) {
    hasAddOn = addOns && addOns.includes(addOn.toLowerCase());
  } else {
    hasAddOn = addOn.length ? addOn.some(function (ad) {
      return hasAddOnAccess(packageAddons, ad);
    }) : true;
  }
  return hasAddOn;
};

// Use this function to check delivery mechanisms like: Pro, Feeds, Data API
function dependsOnDeliveryMechanism(deliveryMechanism, delivery, property) {
  var defaultValue = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  return checkIfDeliveryMechanismHasDelivery(deliveryMechanism, delivery) ? property : defaultValue;
}
function checkIfDeliveryMechanismHasDelivery(deliveryMechanism, delivery) {
  if (!deliveryMechanism) {
    return false;
  }
  return Array.isArray(deliveryMechanism) ? deliveryMechanism.includes(delivery) : deliveryMechanism === delivery;
}
var downloadTypeForMultiplePackages = function downloadTypeForMultiplePackages() {
  var downloadType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  if (downloadType.includes("fd")) {
    return "fd";
  } else if (downloadType.includes("ld")) {
    return "ld";
  }
  return "nd";
};
var getUserFromAccessToken = function getUserFromAccessToken(accessToken, application) {
  var subscriptions = pathOr__default["default"]([], [_typeof(accessToken.preqin_subscription)], {
    string: [accessToken.preqin_subscription],
    array: accessToken.preqin_subscription,
    object: accessToken.preqin_subscription,
    undefined: []
  }).map(function (subscription) {
    return {
      id: subscription
    };
  });
  if (application === "pro") {
    var secAddOn = "sec";
    var deliveryMechanism = accessToken === null || accessToken === void 0 ? void 0 : accessToken.preqin_deliverymechanism;
    var purchasedPackage = {
      name: accessToken === null || accessToken === void 0 ? void 0 : accessToken.preqin_category,
      assetClasses: accessToken === null || accessToken === void 0 ? void 0 : accessToken.preqin_assetclasses,
      addOns: accessToken === null || accessToken === void 0 ? void 0 : accessToken.preqin_addons,
      downloadType: accessToken === null || accessToken === void 0 ? void 0 : accessToken.preqin_download
    };
    if (purchasedPackage.downloadType && Array.isArray(purchasedPackage.downloadType)) {
      var downloadType = purchasedPackage === null || purchasedPackage === void 0 ? void 0 : purchasedPackage.downloadType;
      // precedence for downloadType in case of multiple packages is -- fd,ld,nd
      purchasedPackage.downloadType = downloadTypeForMultiplePackages(downloadType);
    }

    //add sec as asset classes if sec is addon
    if (hasAddOnAccess(purchasedPackage.addOns, secAddOn)) {
      purchasedPackage.assetClasses = Array.isArray(purchasedPackage.assetClasses) ? [].concat(_toConsumableArray(purchasedPackage.assetClasses), [secAddOn]) : [purchasedPackage.assetClasses, secAddOn];
    }
    //geographies changes
    var decodedRegion = accessToken.preqin_geographies;
    var region = decodedRegion ? decodedRegion : ["geo_gl"];
    region = region && (Array.isArray(region) ? region : [region]);
    return new User(accessToken.preqin_userName, accessToken.name, subscriptions, undefined, accessToken.preqin_userId, accessToken.preqin_contactFirmId, accessToken.preqin_firmId, accessToken.preqin_firmName, accessToken.firmType, accessToken.preqin_firmType, accessToken.subscription_count_classic, accessToken.subscription_count_pro, dependsOnDeliveryMechanism(deliveryMechanism, "pro", purchasedPackage, {}), region, accessToken.preqin_firmCountry);
  }
  return new User$1(accessToken.preqin_userName, accessToken.name, subscriptions, undefined, accessToken.preqin_userId, accessToken.preqin_contactFirmId, accessToken.firmType, accessToken.subscription_count_classic, accessToken.subscription_count_pro, accessToken.preqin_role, accessToken.preqin_maintenance_userId, accessToken.preqin_maintenance_userInitials, accessToken.preqin_firmId, accessToken.preqin_firmName, accessToken.preqin_firmCountry);
};

exports["default"] = getUserFromAccessToken;
